import React from 'react';
import { bool } from 'prop-types';

import { usePromoModel } from '../../../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../../../contexts/PromoCartProvider';
import { NumProducts } from '../NumProducts/NumProducts';

export const BogoSecondaryMessaging = ({ isInPromoDrawer }) => {
  const { bogoMaxQuantity, singleItemIdToDisplay } = usePromoModel();
  const { promoSuccessLevel } = usePromoCart();

  if (promoSuccessLevel === 'almost') {
    if (isInPromoDrawer) return <>Add your items to cart or edit your items below</>;

    return (
      <>
        <span className="u__bold">Don&#39;t forget </span>
        <span>to </span>
        <span className="u__bold">add both items to cart </span>
        {singleItemIdToDisplay ? (
          <span>below</span>
        ) : (
          <span className="u__default-link" type="button">Edit</span>
        )}
      </>
    );
  }

  if (promoSuccessLevel === 'success') {
    if (isInPromoDrawer) return <>Edit your selection below, then go to cart</>;

    return (
      <>
        <div className="u__bold">
          <span className="promo-messaging-container--success">Success! </span>
          <span className="promo-messaging-container__large-screen-text">Enjoy your free item&nbsp;</span>
          {!singleItemIdToDisplay && <span className="u__default-link" type="button">Edit</span>}
        </div>
        <span className="u__legal">(Limit of {bogoMaxQuantity} Per Order)</span>
      </>
    );
  }

  return (
    <>
      {singleItemIdToDisplay ? (
        <>Select Your Free Product below</>
      ) : (
        <>Choose Your Free Product <NumProducts actionable={!isInPromoDrawer} /></>
      )}
    </>
  );
};

BogoSecondaryMessaging.displayName = 'BogoSecondaryMessaging';

BogoSecondaryMessaging.propTypes = {
  isInPromoDrawer: bool,
};

BogoSecondaryMessaging.defaultProps = {
  isInPromoDrawer: false
};
